export default __webpack_public_path__ + "static/media/liferheld.aea196ba.svg";